<div class="row clickable" (click)="expanded = !expanded">
	<div class="col-auto">
		<i class="fa-sharp fa-solid fa-chevron-right faq-chevron"></i>
	</div>
	<div class="col">
		<h4 class="mb-0">
			<ng-content select="[question]"></ng-content>
		</h4>

		<div class="faq-answer mt-3" *ngIf="expanded">
			<ng-content></ng-content>
		</div>
	</div>
</div>